import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BillingManagementService } from '../../../service/billing-management.service';
import { KeyValues5, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-bill-history',
  templateUrl: './bill-history.component.html',
  styleUrls: ['./bill-history.component.scss']
})
export class BillHistoryComponent implements OnInit {
  billingId = ''; maxBodyHeight = 0; items: KeyValues5[];
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.billingManagementService.getBillingStatusHistory(this.billingId).subscribe(result => {
      this.items = result;
    });
  }
}
